import client from './client';

// 세금계산서 회차 1건의 수금(지급) 계획 N개(선금/중도금/잔금). bito 신설(2026-10-21,
// 설계: obsidian bito/수금·지급 계획 N개 설계(2026-10-21).md) - OrderBillReviewPanel의
// 2단 펼침(회차→계획→수금내역)과 계획 관리 다이얼로그가 이 API를 쓴다.
const baseUrl = '/api/v1/project/orders/bill-collect/plan';

// 이 회차의 계획 목록(배분액/잔액/상태 계산값 포함). 계획이 없으면 서버가 "전액 1개"를
// 지연 생성해 돌려준다.
export const getPlans = (invUuid) => client.get(`${baseUrl}/${invUuid}`);

// 계획 통째로 재구성. 배분(수금)이 걸린 계획은 서버가 그대로 보존하고, 금액이 다르면 막는다.
// payload: BillCollectPlanDto[] - { planUuid?, planNm, planMemo, planDt, planAmt }
export const replacePlans = (invUuid, plans) => client.put(`${baseUrl}/${invUuid}`, plans);

// 일정 관리 캘린더 [수금예정]/[지급예정] 칩(2026-10-21 2차 릴리스) - 회차마다 "가장 이른
// 미완료 계획" 하나씩, 조회 기간에 그 계획일이 드는 것만.
export const getCalendarPlans = (invTyp, strtDt, endDt) =>
  client.get(`${baseUrl}/calendar`, { params: { invTyp, strtDt, endDt } });
